import { Box, Button, Typography, Dialog } from "@mui/material";

const Image = ({ src, alt, style }: any) => <Box component="img" src={src} alt={alt} style={style} loading="lazy" />;

const GreatGoing = ({ handleClose, open, currentSection }: any) => {
  return (
    <Dialog open={open} onClose={handleClose} fullScreen>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#756DE9",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between", // This will push content to the edges
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 20,
            left: 0,
            right: 0,
            width: 77,
            height: 40,
            margin: "auto",
          }}
        >
          <Image src="/images/Seevi-Logo-White.png" alt="Seevi Logo" style={{ width: 77, height: 40 }} />
        </Box>

        <Box px={6} pt={22}>
          <Typography variant="h4" align="center" sx={{ color: "white", fontWeight: 600, fontSize: "30px" }}>
            {currentSection === 0 ? "Great Going!" : "Keep the spirit high!"}
          </Typography>
          <Typography
            variant="h6"
            align="center"
            sx={{ color: "white", fontWeight: "medium", mt: 2, fontSize: "18px" }}
          >
            {currentSection === 0 ? "Only 15 more questions to complete section 1" : "You are on the last leg"}
          </Typography>
        </Box>

        <Box
          sx={{
            position: "relative", // Change to relative to keep it in the flow
            bottom: 100, // Adjust spacing if needed
            left: 0,
            right: 0,
            width: "100%",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          <Image src={currentSection === 0 ? "/images/SectionOne.svg" : "/images/GreatGoing.svg"} alt="Section 1" />
          <Button
            sx={{
              fontWeight: 600,
              backgroundColor: "white",
              borderRadius: "99px",
              fontSize: "16px",
              textTransform: "capitalize",
              width: "90%",
              color: "#756DE9",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
              padding: "15px 40px",
            }}
            variant="contained"
            size="small"
            onClick={handleClose}
          >
            Let&apos;s Go!
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default GreatGoing;
